import {useOpenSupportTicket} from '../useOpenSupportTicket';
import {Dropdown, Menu} from 'antd';
import {useTicketActions} from '../useTicketActions';

/**
 * Three-dot quick-actions dropdown for a ticket row in the list/table view.
 * Extracted into its own component so it can call the useTicketActions hook
 * per row (hooks can't run inside a column render callback).
 */
export const TicketRowActions = ({
  ticket,
  onChanged,
  actionBtnClassName,
  threeDotClassName,
}) => {
  const openTicket = useOpenSupportTicket();
  const {
    canAssignToMe,
    canResolve,
    assignToMe,
    resolve,
    resolveModal,
    loading,
  } = useTicketActions(ticket, onChanged);

  const menu = (
    <Menu>
      <Menu.Item
        key="1"
        onClick={e => {
          e.domEvent.stopPropagation();
          openTicket(ticket.id);
        }}>
        Open Conversation
      </Menu.Item>
      {canAssignToMe && (
        <Menu.Item
          key="2"
          disabled={loading}
          onClick={e => {
            e.domEvent.stopPropagation();
            assignToMe();
          }}>
          Assign to Me
        </Menu.Item>
      )}
      {canResolve && (
        <Menu.Item
          key="5"
          disabled={loading}
          onClick={e => {
            e.domEvent.stopPropagation();
            resolve();
          }}>
          Mark as Resolved
        </Menu.Item>
      )}
    </Menu>
  );

  return (
    <>
      <Dropdown overlay={menu} trigger={['click']} placement="bottomRight">
        <div className={actionBtnClassName} onClick={e => e.stopPropagation()}>
          <span className={threeDotClassName}>&#8942;</span>
        </div>
      </Dropdown>
      {/* Portal events still bubble through React: keep dialog clicks from
          reaching the row, which opens the ticket. */}
      <span onClick={e => e.stopPropagation()}>{resolveModal}</span>
    </>
  );
};
